import { Component, ViewChild } from '@angular/core';
import { BASIC_IMPORTS, MATERIAL_IMPORTS } from '../../imports/common-imports';
import { MatDialogRef } from '@angular/material/dialog';
import { MonthlyComponent } from './monthly/monthly.component';

@Component({
  selector: 'app-date-picker-dialog',
  standalone: true,
  imports: [MonthlyComponent, MATERIAL_IMPORTS, BASIC_IMPORTS],
  templateUrl: './date-picker-dialog.component.html',
  styleUrl: './date-picker-dialog.component.scss',
})
export class DatePickerDialogComponent {
  @ViewChild(MonthlyComponent) monthlyComponent!: MonthlyComponent;
  constructor(
    private readonly dialogRef: MatDialogRef<DatePickerDialogComponent>,
  ) {}

  clear() {
    this.monthlyComponent.clear();
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.monthlyComponent.saveData();

    this.dialogRef.close({ refresh: true });
  }
}
